export enum Feedback {
  ThumbsUp,
  ThumbsDown
}

export const FeedbackMap = {
  [Feedback.ThumbsUp]: '👍',
  [Feedback.ThumbsDown]: '👎'
};
